import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import logo from "../images/logo.jpg";

const links = [
  ["Home", "#hero"],
  ["Hajj & Umrah", "#hajjumrah"],
  ["Visa", "#visas"],
  ["Air Tickets", "#airticket"],
  ["License", "#license"],
  ["Destinations", "#destinations"],
  ["Gallery", "#gallery"],
  ["Hotels", "#hotels"],
  ["Ziyrat & Car Rental", "#carrent"],
  ["Domestic Packages", "#packages"],
  ["About", "#about"],
  ["Contact", "#contact"],
];

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 glass-light transition-all duration-300 ${
        scrolled ? "py-2 bg-white/90 shadow-soft" : "py-4 bg-white/90 shadow-soft"
      }`}
    >
      <div className="flex w-full items-center justify-between gap-4 px-4 lg:px-6 2xl:px-10">
        {/* Brand */}
        <a href="#hero" className="flex shrink-0 items-center gap-3">
          <img
            src={logo}
            alt="Chalo Makkah Sharif"
            className={`rounded-full object-cover shadow-soft transition-all duration-300 ${
              scrolled ? "h-10 w-10" : "h-12 w-12"
            }`}
          />
          <span className="hidden leading-tight lg:block">
            <span className="block whitespace-nowrap text-base font-extrabold text-brand-dark">
              <span className="text-brand-green">CHALO</span> MAKKAH SHARIF
            </span>
            <span className="block text-[9px] font-semibold uppercase tracking-[2px] text-brand-orange">
              Tours &amp; Travels
            </span>
          </span>
        </a>

        {/* Desktop links */}
        <ul className="hidden flex-1 items-center justify-center gap-x-3 lg:flex xl:gap-x-4 2xl:gap-x-6">
          {links.map(([label, href]) => (
            <li key={href}>
              <a
                href={href}
                className="group relative whitespace-nowrap text-[12px] font-medium text-brand-dark transition-colors hover:text-brand-green xl:text-[13px]"
              >
                {label}
                <span className="absolute -bottom-1.5 left-0 h-0.5 w-0 rounded bg-gradient-to-r from-brand-green to-brand-gold transition-all duration-300 group-hover:w-full" />
              </a>
            </li>
          ))}
        </ul>

        {/* CTA + hamburger */}
        <div className="flex shrink-0 items-center gap-3">
          <a
            href="#contact"
            className="hidden rounded-full bg-gradient-to-br from-brand-green to-[#3a9410] px-5 py-2.5 text-sm font-semibold text-white shadow-[0_10px_26px_rgba(76,175,24,0.45)] transition-transform hover:-translate-y-0.5 xl:inline-flex"
          >
            Book Now →
          </a>
          <button
            onClick={() => setMenuOpen((o) => !o)}
            aria-label="Toggle menu"
            className="text-3xl leading-none text-brand-dark transition-transform lg:hidden"
          >
            {menuOpen ? "✕" : "☰"}
          </button>
        </div>
      </div>

      {/* Mobile / tablet drawer */}
      <AnimatePresence>
        {menuOpen && (
          <motion.ul
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="overflow-hidden bg-white/95 px-6 backdrop-blur-md lg:hidden"
          >
            {links.map(([label, href]) => (
              <li key={href} className="border-b border-black/5 last:border-0">
                <a
                  href={href}
                  onClick={() => setMenuOpen(false)}
                  className="block py-3 text-sm font-medium text-brand-dark transition-colors hover:text-brand-green"
                >
                  {label}
                </a>
              </li>
            ))}
            <li className="py-4">
              <a
                href="#contact"
                onClick={() => setMenuOpen(false)}
                className="inline-flex rounded-full bg-gradient-to-br from-brand-orange to-[#e07a00] px-6 py-2.5 text-sm font-semibold text-white shadow-[0_10px_26px_rgba(247,148,29,0.5)]"
              >
                Book Now →
              </a>
            </li>
          </motion.ul>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
